import { Component, Input, OnInit } from '@angular/core';
import { AccountConfigService } from '../../../services/account-config/account-config.service';
import { SessionService } from '../../../services/session/session.service';

@Component({
  selector: 'ags-session-information',
  templateUrl: './session-information.component.html',
  styleUrls: ['./session-information.component.scss']
})
export class SessionInformationComponent implements OnInit {
  public syntheseSessionData: any;
  public syntheseSiteData: any;
  public syntheseClientsData: any;
  public syntheseIndicesData: any;
  public syntheseCategoriesData: any;
  public prerequisSessionData: any;
  public modalite = '';
  inter = '';
  titre = '';
  indices = [];
  public idSession;
  public themeFlag = '';
  public hoursSession: any;
  public daysSession: any;
  public dateDebut: Date;
  public dateFin: Date;
  surchargeHeureAcadomia = { b_actif: false };
  @Input('idSession')
  set _idSession(value: string) {
    if (value) {
      this.idSession = value;
    }
  }
  constructor(private accountConfigService: AccountConfigService, private sessionService: SessionService) {}

  ngOnInit() {
    this.sessionService
      .moducleChecker('ACADOMIA_SURCHARGE_HORAIRE_SESSION')
      .subscribe(data => (this.surchargeHeureAcadomia = data[0]));
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
    this.getSessioninfo(this.idSession);
  }

  getSessioninfo(idSession) {
    this.sessionService.getSessionSynthese(idSession).subscribe((syntheseSessionData: any) => {
      this.syntheseSessionData = syntheseSessionData.session[0];
      this.syntheseSiteData = syntheseSessionData.site_principal[0];
      this.syntheseClientsData = syntheseSessionData.clients;
      this.syntheseIndicesData = syntheseSessionData.indices;
      this.syntheseCategoriesData = syntheseSessionData.categories;
      this.loadSessionInfos(this.syntheseSessionData);
    });
  }

  loadSessionInfos(synthese: {
    session_date_fin: any;
    session_date_debut: any;
    mod_acadomia_planif_intervenant: any;
    date_debut: any;
    date_fin: any;
    duree_heure: any;
    duree_jour: any;
    duree_jours: any;
    duree_heures: any;
  }) {
    if (synthese.mod_acadomia_planif_intervenant) {
      if (synthese.session_date_debut && synthese.session_date_fin && synthese.duree_heure) {
        this.hoursSession = synthese.duree_heures;
        this.daysSession = synthese.duree_jour ? synthese.duree_jour : synthese.duree_jours;
        this.dateDebut = synthese.session_date_debut;
        this.dateFin = synthese.session_date_fin;
      } else {
        this.hoursSession = synthese.duree_heures;
        this.daysSession = synthese.duree_jours;
        this.dateDebut = synthese.date_debut;
        this.dateFin = synthese.date_fin;
      }
    } else {
      this.hoursSession = synthese.duree_heures;
      this.daysSession = synthese.duree_jours || synthese.duree_jour;
      this.dateDebut = synthese.date_debut || synthese.session_date_debut;
      this.dateFin = synthese.date_fin || synthese.session_date_fin;
    }
  }

  getModalite() {
    if (this.syntheseSessionData) {
      switch (this.syntheseSessionData.type_modalite) {
        case 1:
          this.modalite = 'Présentiel';
          return this.modalite;
        case 2:
          this.modalite = 'Présentiel';
          return this.modalite;
        case 3:
          this.modalite = 'Blended';
          return this.modalite;
      }
    }
    return null;
  }

  getInter() {
    if (this.syntheseSessionData) {
      if (this.syntheseSessionData.b_inter === true) {
        this.inter = 'Inter-établissements';
      } else {
        this.inter = 'Intra-établissements';
      }
      return this.inter;
    }
    return null;
  }

  getTitre() {
    if (this.syntheseIndicesData) {
      if (this.syntheseIndicesData.length > 0) {
        this.titre = 'Indices';
      }
      if (this.syntheseCategoriesData.length > 0) {
        this.titre = 'Catégories';
      }
      return this.titre;
    }
    return null;
  }
}
